import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import Routes from './Routes'
import { GoogleOAuthProvider } from '@react-oauth/google';

// styles
import GlobalStyle from './styles/global'
import HelpersStyle from './styles/helpers'

import { AuthProvider } from './hooks/auth'

function App() {
  return (
    <Router>
      <AuthProvider>
        <GoogleOAuthProvider clientId="927848170582-8bd3pnv2kripa3duielqcib7bkamubk0.apps.googleusercontent.com">
          <Routes />
        </GoogleOAuthProvider>
      </AuthProvider>

      <GlobalStyle />
      <HelpersStyle />
    </Router>
  );
}

export default App;
